/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { AperzaTVTreasure } from './treasureExtension';
import { useAuth } from '../contexts/AuthContext';
export const usePageViewTracking = () => {
    const history = useHistory();
    const { currentUser } = useAuth();
    const trackPageview = () => {
        AperzaTVTreasure.pageView(window.location.href, currentUser.userId);
    };
    useEffect(() => {
        trackPageview();
        const unlisten = history.listen(trackPageview); // Track all subsequent pageviews
        return () => unlisten();
    }, [history]);
};
